import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { OnInit } from '@angular/core';
import { initFlowbite } from 'flowbite';
import { LoadingService } from './@shared/loading.service';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Option Sniper';

  constructor(public loadingService: LoadingService) {

  }

  ngOnInit(): void {
    initFlowbite();
  }
}
